import React, { useMemo, useEffect } from "react";
import { connect } from "react-redux";
import Button from "../../Components/Button/Button";
import Header from "../../Components/Header/Header";
import {
  clearExistingComplaint,
  showSelectedExistingComplaint
} from "../../Redux/complaints/action";

function SuccessFallback(props) {
  const locationData = useMemo(() => {
    if (props.locations.selectedLocation && props.locations.data) {
      return props.locations.data?.[props.locations.selectedLocation] || null;
    } else {
      return null;
    }
  }, [props.locations.selectedLocation, props.locations.data]);

  useEffect(() => {
    if (!props.complaints?.existingComplaints) {
      props.navigate("/complaints");
    }
    return () => {
      props.clearExistingComplaint();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="inherit-parent-width inherit-parent-height flex-center-children-horizontally">
      <div className="max-width-767px inherit-parent-width inherit-parent-height">
        <Header
          title="Customer Support"
          backOnClick={() => {
            clearExistingComplaint();
            props.navigate("/complaints");
          }}
          profileOnClick={props.profileOnClick}
        />

        <div className="padding-large parent-height-sub-64px">
          <div
            className=" inherit-parent-width display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
            style={{ height: "calc(100% - 44px)" }}
          >
            <div className="wrapper padding-bottom-larger">
              <svg className="checkmark" viewBox="0 0 52 52">
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            </div>

            <div className="font-size-default font-family-RHD-medium text-align-center ">
              Existing active complaint
            </div>
            <div className="font-size-medium text-align-center padding-top-small ">
              You have already submitted an active complaint for <br />{" "}
              {locationData
                ? `${locationData?.PCTNo}, ${locationData?.location}`
                : ""}
            </div>
            <div className="font-size-medium text-align-center padding-top-small ">
              Complaint ID
            </div>
            <div
              style={{ display: "ruby" }}
              className="font-size-medium text-align-center padding-top-small "
            >
              {props.complaints?.existingComplaints?.map((data, index) => (
                <div
                  key={index}
                  className=" cursor-pointer margin-right-small "
                  style={{ borderBottom: " 1px solid #404040" }}
                  onClick={() => {
                    props.showSelectedExistingComplaint(data, props.navigate);
                  }}
                >
                  {data?.documentId || ""}
                  {props.complaints?.existingComplaints?.length - 1 !== index
                    ? ","
                    : ""}{" "}
                </div>
              ))}
            </div>
          </div>

          <Button
            text="Okay"
            data-cy="okay-button"
            type="submit"
            boxShadow={false}
            // loading={props.complaints?.raiseComplaintsLoading}
            // disabled={handleDisable}
            onClick={() => {
              props.clearExistingComplaint();
              props.navigate("/complaints");
            }}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = function (state) {
  return {
    complaints: state.complaints,
    locations: state.locations
  };
};

const mapDispatchToProps = function () {
  return {
    clearExistingComplaint: () => clearExistingComplaint(),
    showSelectedExistingComplaint: (data, navigate) =>
      showSelectedExistingComplaint(data, navigate)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessFallback);
